import { render, staticRenderFns } from "./application_sphere.vue?vue&type=template&id=a43f3fa8"
import script from "./application_sphere.vue?vue&type=script&lang=js"
export * from "./application_sphere.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports